export type BrowserLanguage = string;

export const SET_BROWSER_LANGUAGE = 'SET_BROWSER_LANGUAGE';

export interface BrowserLanguageAction {
	type: typeof SET_BROWSER_LANGUAGE;
	payload: BrowserLanguage;
}
